import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import buildSubjectPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectPath';
/**
 * The review screen of a document opened from a preparation: `stage` is the 0-indexed stage whose
 * documents the screen shows as tabs and verifies together.
 */
const buildReviewPath = (
	subject: SubjectAddress,
	documentId: number,
	preparationId: number,
	stage: number,
): string =>
	`${buildSubjectPath(subject)}/documents/${documentId}?preparation=${preparationId}&stage=${stage}`;

export default buildReviewPath;
